import React from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import {
  FaUsers,
  FaAd,
  FaChartBar,
  FaReceipt,
  FaHome,
  FaUserCheck,
  FaCog,
  FaUser,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const SubAdminDashboard = () => {
  const navigate = useNavigate();

  const dashboardItems = [
    {
      title: "Local Subscriptions",
      icon: <FaUsers size={24} />,
      description: "Manage subscriptions in your area",
      path: "/subadmin/local-subscriptions",
    },
    {
      title: "Sub-Sub Admins",
      icon: <FaUsers size={24} />,
      description: "Manage sub-sub admins you created",
      path: "/subadmin/subsubadmins",
    },
    {
      title: "Ads Management",
      icon: <FaAd size={24} />,
      description: "Approve or reject ads from vendors in your area",
      path: "/subadmin/ads-management",
    },
    {
      title: "Analytics",
      icon: <FaChartBar size={24} />,
      description: "View analytics for your area",
      path: "/subadmin/analytics",
    },
    {
      title: "Transactions",
      icon: <FaReceipt size={24} />,
      description: "View financial transactions in your area",
      path: "/subadmin/transactions",
    },
  ];

  return (
    <div>
      <h1 className="mb-4">SubAdmin Dashboard</h1>
      <Row>
        {dashboardItems.map((item, index) => (
          <Col md={6} lg={3} className="mb-4" key={index}>
            <Card
              className="h-100 cursor-pointer hover-shadow"
              onClick={() => navigate(item.path)}
              style={{ cursor: "pointer", minHeight: "150px" }}
            >
              <Card.Body className="d-flex flex-column align-items-center text-center justify-content-center">
                <div className="mb-3 text-primary">{item.icon}</div>
                <Card.Title>{item.title}</Card.Title>
                <Card.Text className="text-muted">{item.description}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}

        <Col md={6} lg={3} className="mb-4">
          <Card className="h-100">
            <Card.Header className="bg-light">
              <h5 className="mb-0">System Information</h5>
            </Card.Header>
            <Card.Body>
              <div className="d-flex align-items-center mb-3">
                <FaHome className="text-primary me-2" size={20} />
                <div>
                  <div className="fw-semibold">System</div>
                  <div className="text-muted small">QuiVikme Admin Panel</div>
                </div>
              </div>
              <div className="d-flex align-items-center mb-3">
                <FaUserCheck className="text-success me-2" size={20} />
                <div>
                  <div className="fw-semibold">User Role</div>
                  <div className="text-muted small">Sub Admin</div>
                </div>
              </div>
              <div className="d-flex align-items-center mb-3">
                <FaCog className="text-info me-2" size={20} />
                <div>
                  <div className="fw-semibold">System Status</div>
                  <div className="text-muted small">Operational</div>
                </div>
              </div>
              <div className="d-grid gap-2 mt-3">
                <Button
                  variant="outline-danger"
                  onClick={() => {
                    // Clear all session and local storage
                    sessionStorage.clear();
                    localStorage.removeItem("adminToken");
                    // Redirect to login page
                    window.location.href = "/admin";
                  }}
                >
                  <FaUser className="me-2" />
                  Logout
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <div className="mt-4 p-3 bg-light rounded">
        <h5>SubAdmin Features</h5>
        <p className="mb-0">
          As a SubAdmin, you can manage content within your assigned area. Your
          access is filtered by pincode to show only relevant data for your
          region.
        </p>
      </div>

      <style jsx>{`
        .hover-shadow:hover {
          box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
          transform: translateY(-2px);
          transition: all 0.2s ease-in-out;
        }
        .cursor-pointer {
          cursor: pointer;
        }
      `}</style>
    </div>
  );
};

export default SubAdminDashboard;
